export default {"src":"/_next/static/media/ticket-white-46x46.8b1c5d17.svg","height":21,"width":16};